import React from 'react';
import Tooltip from "components/tooltips/Tooltips";
import UseContext from "hooks/useContext";
import { IntercomIcon } from "assets/icons";

const IntercomDL = () => {
    const { sidebarExpanded } = UseContext();
    const collapsedRail = !sidebarExpanded;
    
    const handleClick = (e) => {
        e.preventDefault();
        window.open('https://app.intercom.com/', '_blank', 'noopener,noreferrer');
    };

    const rowCollapsedCenter = collapsedRail
        ? 'justify-center tab:max-ls:justify-center ls:justify-center tab:sidebar-expanded:justify-start'
        : '';
    const itemPadding = collapsedRail
        ? 'px-2 max-tab:px-2 tab:max-ls:px-0 ls:px-0 tab:sidebar-expanded:px-2'
        : 'px-2';

    return (
        <li>
            <Tooltip
                text="Intercom"
                disabled={sidebarExpanded}
                placement="right"
            >
                <button
                    onClick={handleClick}
                    className={`flex items-center h-[44px] rounded-lg ${itemPadding} py-3 transition duration-150 text-gray-700 bg-transparent hover:bg-gray-100 w-full ${rowCollapsedCenter}`}
                >
                    <span className='shrink-0'>
                        <IntercomIcon wh={24} color='#374151'/>
                    </span>
                    <span
                        className={`ft-sm font-medium truncate ml-4 tab:max-ls:ml-0 tab:sidebar-expanded:ml-4 ${
                            collapsedRail
                                ? 'max-tab:inline tab:max-ls:hidden ls:hidden ls:sidebar-expanded:inline'
                                : ''
                        }`}
                    >
                        Intercom
                    </span>
                </button>
            </Tooltip>
        </li>
    );
};

export default IntercomDL;
